
import Store from "@/store";
import App from "@/App.vue";

export default function hasLoaded(params: IRouterContext) {
    const nextParams: any = {
        path: "/",
    };

    // eslint-disable-next-line no-console
    if (params.from.path !== "/" && params.to.path !== "/") {
        return params.next();
    }

    // Change redirect url
    if (Store.state.hasLoaded === false) {
        const toPath = params.to.path.toLowerCase() === "/experience"
            ? "/birthday"
            : params.to.path;

        Store.state.redirectUrl = toPath;
        return params.next(nextParams);
    }

    // Proceed
    return params.next();
}
